
import React from 'react';
import { Button } from '@/components/ui/button';
import { Phone } from 'lucide-react';
import { usePhoneOrderDialog } from '@/contexts/PhoneOrderDialogContext';

interface PlanOrderButtonProps {
  className?: string;
}

const PlanOrderButton: React.FC<PlanOrderButtonProps> = ({ className }) => {
  const { openPhoneOrderDialog } = usePhoneOrderDialog();
  
  return (
    <Button 
      onClick={openPhoneOrderDialog}
      className={className}
      variant="default"
    >
      <Phone className="mr-2 h-4 w-4" />
      Place Master Reseller Pro Order
    </Button>
  );
};

export default PlanOrderButton;
